import { AlertSettings } from './types';

export const alertSettings: AlertSettings = {
  componentVariants: {
    size: {
      prop: 'size',
      variants: {
        regular: {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'currentColor',
          borderRadius: 1,
          paddingTop: 5,
          paddingRight: 6,
          paddingBottom: 5,
          paddingLeft: 6,
        },
      },
    },
    color: {
      prop: 'color',
      variants: {
        primary: {
          backgroundColor: 'primary.extraLight',
          color: 'primary.dark',
        },
        success: {
          backgroundColor: 'success.extraLight',
          color: 'success.dark',
        },
        danger: {
          backgroundColor: 'danger.extraLight',
          color: 'danger.dark',
        },
      },
    },
  },
};
